module.exports = __webpack_public_path__ + "images/ausbildung.png?aab65ce323697f3fdfb77cc67400725c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ausbildung.png
// module id = oQ1X
// module chunks = 0